/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Findings_Demo_ChannelInputs */



/**
* | output |
* | --- |
* | "help" |
*
* @param {Products_Findings_Demo_ChannelInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_findings_demo_channel = /** @type {((inputs?: Products_Findings_Demo_ChannelInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Findings_Demo_ChannelInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("помощь")
	return /** @type {LocalizedString} */ ("help")
});